import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class RepairFacilityService {
    static getVendorsNearby(params, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('vendor'),
            'proximitySearch',
            [params],
            additionalHeaders
        );
    }
}
